<template>
	<div class="advert-manage-container">
		<!-- 导出卡片 -->
		<el-card shadow="hover" style="margin-bottom: 10px">
			<div class="ladger-header-content">
				<div>
					<div class="ledger-header-title">资产台账</div>
					<div>管理资产信息，查看资产详情和状态</div>
				</div>
			</div>
		</el-card>

		<!-- 数据卡片 -->
		<InfoCards :data="assetStats" />
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.assetNo" placeholder="请输入资产编号" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.assetName" placeholder="请输入资产名称" />
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.assetCategory" placeholder="请选择资产分类" clearable style="width: 100%">
						<el-option
							v-for="(item, index) in $menu.getList('AssetCategory')"
							:key="index"
							:label="item.name"
							:value="item.value" />
					</el-select>
				</el-col>
			</template>
			<template slot="more">
				<el-col :span="6">
					<el-select v-model="query.status" placeholder="请选择资产状态" clearable style="width: 100%">
						<el-option
							v-for="(item, index) in $menu.getList('AssetStatus')"
							:key="index"
							:label="item.name"
							:value="item.value" />
					</el-select>
				</el-col>
			</template>
		</QueryCard>

		<!-- 表格 -->
		<BaseTable
			:actions="{
				add: true,
				import: true,
				export: true,
				operation: true,
			}"
			:loading="loading"
			:exportLoading="exportLoading"
			:importLoading="importLoading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange"
			@add="handleAdd"
			@import="handleImport"
			@export="handleExport">
			<template #assetNo="{ row }">
				<div class="table-assetCode" @click="handleQrcode(row)">
					<span>
						{{ row.assetNo }}
					</span>
					<i class="fa fa-qrcode" style="color: #409eff; font-size: 20px; cursor: pointer"></i>
				</div>
			</template>
			<template #assetCategory="{ row }">
				{{ $menu.getLabel('AssetCategory', row.assetCategory) }}
			</template>
			<template #status="{ row }">
				<el-tag :type="AssetStatus[row.status] || 'default'" size="small">
					{{ $menu.getLabel('AssetStatus', row.status) || '-' }}
				</el-tag>
			</template>
			<template #planningType="{ row }">
				{{ $menu.getLabel('PlanningType', row.planningType) }}
			</template>

			<template #operation="{ row }">
				<el-button type="text" @click="handleShow(row)">查看</el-button>
				<el-button type="text" @click="handleEdit(row)">编辑</el-button>
				<el-button type="text" @click="handleQrcode(row)">打印二维码</el-button>
			</template>
		</BaseTable>

		<!-- 新增，编辑弹窗 -->
		<AssetLedgerDialog
			:dialogVisible.sync="dialogVisible"
			:isEdit="isEdit"
			:data="currentRow"
			@updateSuccess="updateSuccess" />
		<AssetImportDialog
			:dialogVisible.sync="importDialogVisible"
			:importFn="importAsset"
			:downloadTemplateFn="downloadImportTemplate"
			@updateSuccess="onImportSuccess" />
		<AssetLedgerQrcode :dialogVisible.sync="qrcodeDialogVisible" :data="currentRow" />
		<AssetLedgerDrawer :dialogVisible.sync="drawerVisible" :data="currentRow" @showQrcode="showQrcode" />
	</div>
</template>

<script>
	import { getAssetPage, getAssetStatistics, exportAssetList, importAsset, downloadImportTemplate } from '@/api/asset/assetLedgerApi.js';
	import AssetLedgerDialog from '@/components/asset/assetLedgerDialog';
	import AssetLedgerQrcode from '@/components/asset/assetLedgerQrcode';
	import AssetLedgerDrawer from '@/components/asset/assetLedgerDrawer';
	import AssetImportDialog from '@/components/asset/assetImportDialog';
	import { getCommunityId } from '@/utils/vc.js';
	import { AssetStatus } from '@/utils/meunType.js';
	export default {
		name: 'AssetLedger',
		components: { AssetLedgerDialog, AssetLedgerQrcode, AssetLedgerDrawer, AssetImportDialog },
		data() {
			return {
				AssetStatus,
				assetStats: [
					{ key: 'totalCount', label: '总资产数量', unit: '个', color: '#5B8FF9', value: 0 },
					{ key: 'qrcodeRate', label: '一物一码完成率', unit: '%', color: '#5AD8A6', value: 0 },
					{ key: 'inUseCount', label: '在用资产', unit: '个', color: '#67C23A', value: 0 },
					{ key: 'idleCount', label: '闲置资产', unit: '个', color: '#F6BD16', value: 0 },
					{ key: 'disposedCount', label: '已处置资产', unit: '个', color: '#E8684A', value: 0 },
				],
				total: 0,
				query: {
					assetNo: '',
					assetName: '',
					assetCategory: '',
					communityId: getCommunityId(),
					status: '',
					pageNum: 1,
					pageSize: 10,
				},
				tableData: [],
				columns: [
					{ prop: 'assetNo', label: '资产编号', slot: 'assetNo' },
					{ prop: 'assetName', label: '资产名称' },
					{ prop: 'assetCategory', label: '资产分类', slot: 'assetCategory' },
					{ prop: 'buildingArea', label: '建筑面积(㎡)' },
					{ prop: 'originalValue', label: '资产原值(元)' },
					{ prop: 'status', label: '资产状态', slot: 'status' },
					{ prop: 'planningType', label: '规划类型', slot: 'planningType' },
					{ prop: 'accumulatedDepreciation', label: '累计折旧(元)' },
					{ prop: 'netValue', label: '资产净值(元)' },
				],
				loading: false,
				exportLoading: false,
				importLoading: false,
				dialogVisible: false,
				importDialogVisible: false,
				qrcodeDialogVisible: false,
				drawerVisible: false,
				isEdit: false,
				currentRow: {},
			};
		},
		computed: {
			statusMap() {
				const map = {};
				this.AssetStatusOptions.forEach(item => {
					map[item.value] = item.name;
				});
				return map;
			},
		},
		created() {
			this.query.assetNo = this.$route.query.assetNo || '';
			this.fetchAssetStatistics();
			this.getList();
		},
		methods: {
			// 模板直接引用的 API 方法
			importAsset,
			downloadImportTemplate,
			exportAssetList,
			async fetchAssetStatistics() {
				try {
					const res = await getAssetStatistics({
						communityId: this.query.communityId,
					});
					this.assetStats = this.assetStats.map(item => ({
						...item,
						value: res[item.key] || 0,
					}));
				} catch (err) {
					console.log(err);
				}
			},
			async getList() {
				try {
					this.loading = true;
					const res = await getAssetPage(this.query);
					this.total = Number(res.total);
					this.tableData = res.records || [];
				} catch (err) {
					console.log(err);
				} finally {
					this.loading = false;
				}
			},
			pageChange(page) {
				this.query.pageNum = page;
				this.getList();
			},
			sizeChange(size) {
				this.query.pageSize = size;
				this.getList();
			},
			handleSearch() {
        this.query.pageNum = 1;
				this.getList();
			},
			handleReset() {
				this.query = {
					assetNo: '',
					assetName: '',
					assetCategory: '',
					communityId: getCommunityId(),
					status: '',
					pageNum: 1,
					pageSize: 10,
				};
				this.getList();
			},
			handleAdd() {
				this.isEdit = false;
				this.currentRow = {};
				this.dialogVisible = true;
			},
			handleEdit(row) {
				this.isEdit = true;
				this.currentRow = row;
				this.dialogVisible = true;
			},
			handleImport() {
				this.importDialogVisible = true;
			},
			onImportSuccess() {
				this.fetchAssetStatistics();
				this.getList();
			},
			handleExport() {
				if (this.exportLoading) return;
				const params = {
					pageNum: this.query.pageNum,
					pageSize: this.query.pageSize,
					communityId: this.query.communityId,
					assetNo: this.query.assetNo,
					assetName: this.query.assetName,
					assetCategory: this.query.assetCategory,
					status: this.query.status,
				};
				this.exportLoading = true;
				exportAssetList(params)
					.then(response => {
						const blob = new Blob([response.data]);
						let fileName = '资产列表.xlsx';
						const disposition = response.headers && response.headers['content-disposition'];
						if (disposition) {
							const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
							const normalMatch = disposition.match(/filename="?([^";]+)"?/i);
							const raw = utfMatch ? utfMatch[1] : (normalMatch ? normalMatch[1] : '');
							if (raw) {
								fileName = decodeURIComponent(raw);
							}
						}
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.style.display = 'none';
						link.href = url;
						link.setAttribute('download', fileName);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
						this.$message.success('导出成功');
					})
					.catch(err => {
						console.log(err);
						this.$message.error('导出失败');
					})
					.finally(() => {
						this.exportLoading = false;
					});
			},
			handleShow(row) {
				this.currentRow = row;
				this.drawerVisible = true;
			},
			handleQrcode(row) {
				this.currentRow = row;
				this.qrcodeDialogVisible = true;
			},
			showQrcode() {
				this.qrcodeDialogVisible = true;
			},
			updateSuccess() {
				this.query.pageNum = 1;
				this.query.pageSize = 10;
				this.getList();
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		color: #1c1c1c;
		text-align: left;
	}
	.ledger-header-title {
		width: 100%;
		font-weight: bold;
		margin-bottom: 5px;
	}
	.ladger-header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.table-assetCode {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>
